/**
 * Haptic feedback utility for native app feel.
 * Uses Capacitor Haptics plugin on native, no-op on web.
 */

let HapticsPlugin = null;

async function getHaptics() {
  if (HapticsPlugin !== null) return HapticsPlugin;
  try {
    const { Capacitor } = await import("@capacitor/core");
    if (Capacitor.isNativePlatform()) {
      const { Haptics } = await import("@capacitor/haptics");
      HapticsPlugin = Haptics;
    } else {
      HapticsPlugin = false;
    }
  } catch {
    HapticsPlugin = false;
  }
  return HapticsPlugin;
}

export async function hapticSuccess() {
  const h = await getHaptics();
  if (h) {
    try { await h.notification({ type: "SUCCESS" }); } catch {}
  }
}

export async function hapticLight() {
  const h = await getHaptics();
  if (h) {
    try { await h.impact({ style: "LIGHT" }); } catch {}
  }
}

export async function hapticMedium() {
  const h = await getHaptics();
  if (h) {
    try { await h.impact({ style: "MEDIUM" }); } catch {}
  }
}
